export function loadOptions(options, field) {
  if (field.datasourceType === 'remote') {
    options[field.settings.datasource ? field.settings.datasource : field.name] = [];
  } else if (field.datasourceType === 'dictionary') {
    options[field.settings.datasource ? field.settings.datasource : field.name] = [];
  } else if (field.datasourceType === 'table') {
    options[field.settings.datasource ? field.settings.datasource : field.name] = [];
  }
}
